import cx from "classnames";
import type { ReactNode } from "react";
import styles from "./Container.module.scss";

type ContainerProps = {
  children: ReactNode;
  className?: string;
  narrow?: boolean;
};

export const Container = ({
  children,
  className,
  narrow = false,
}: ContainerProps) => (
  <div
    className={cx(styles.container, {
      [styles.narrow]: narrow,
    }, className)}
  >
    {children}
  </div>
);
